/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const get = (st: SpanTag, nickname: string): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/plan/${nickname}`;
  return fetchAPI(stleaf(st, 'owie2r'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export const getAll = (st: SpanTag): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/plan`;
  return fetchAPI(stleaf(st, 'eef9eu'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
